import {
	Component,
	OnInit,
	ChangeDetectorRef,
	ViewChild,
	ElementRef
} from "@angular/core";
import { Router } from "@angular/router";
import { GlobalService } from "../../../services/global/global.service";
import { Observable } from "rxjs";
import { DMVStoreService } from "../../../services/dmv/dmv-store.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DonationOrgs } from "src/app/models/dmv/donationOrgs";
import { DonationOrg } from "src/app/models/dmv/donationOrg";
import { Donation } from "src/app/models/dmv/donation";
import { AgencyDmvConfigResponse } from "src/app/models/dmv/agency-config.response";
import { RouteFrom } from "../../../models/routeFrom";
import { AppUtil } from "../../../utils/app.util";
import { MailingAddress } from "src/app/models/dmv/mailingAddress";
import { Registration } from "src/app/models/dmv/registration";
@Component({
	selector: "app-donation",
	templateUrl: "./donation.component.html",
	styleUrls: ["./donation.component.css"]
})
export class DmvDonationComponent implements OnInit {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		private formBuilder: FormBuilder,
		private cd: ChangeDetectorRef
	) {}
	@ViewChild("selectDonation", { static: false })
	selectDonation: ElementRef;

	@ViewChild("amountInput", { static: false })
	amountInput: ElementRef;
	public amount: any = 0;
	public agencyConfig: AgencyDmvConfigResponse;
	public isloading: boolean = false;
	public donationOrg: DonationOrg;
	public donationOrgsData: DonationOrgs;
	public donationForm: FormGroup;
	public submitted = false;
	public errorMessage: string;
	ngOnInit() {
		AppUtil.log("DmvDonationComponent ngOnInit()");
		if (!this.donationOrgsData) {
			this.isloading = true;
			this.errorMessage = null;
			this.dmvStoreService.findDonationOrgs();
			this.dmvStoreService.donationOrgs$.subscribe(response => {
				if (response) {
					this.isloading = false;

					if (response["status"] && response["status"] !== 200) {
						this.errorMessage = this.dmvStoreService.agencyConfig.agencyDmvConfig.systemFailureText;
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					} else {
						this.donationOrgsData = response.donationOrgs;
						this.cd.markForCheck();
					}
				}
			});
		} else {
			this.donationOrgsData = null;
		}

		this.dmvStoreService.agencyConfig$.subscribe(agencyConfig => {
			if (agencyConfig) {
				this.agencyConfig = agencyConfig;
			}
		});

		this.setOrg(
			this.dmvStoreService.registrationsInCart.donation
				? this.dmvStoreService.registrationsInCart.donation.orgCode
				: ""
		);
		if (this.dmvStoreService.registrationsInCart.isDonationNoThanks === true) {
			setTimeout(() => {
				this.selectDonation.nativeElement.value = "noThanks";
			});
		}
	}

	public get f() {
		return this.donationForm.controls;
	}

	public setOrg(value) {
		AppUtil.log("DmvDonationComponent setOrg() == >", value);
		if (value !== "" && value !== "noThanks" && value !== "selectDonation") {
			this.donationOrgsData.forEach(item => {
				if (item.orgCode === value) {
					this.donationOrg = item;
				}
			});

			if (this.donationOrg) {
				setTimeout(() => {
					this.amountInput.nativeElement.focus();
				});
			}

			if (
				this.dmvStoreService.registrationsInCart.donation &&
				this.dmvStoreService.registrationsInCart.donation.amount
			) {
				this.amount = this.dmvStoreService.registrationsInCart.donation.amount;
			} else {
				this.amount =
					this.donationOrg && this.donationOrg.minAmount
						? this.donationOrg.minAmount
						: 0;
			}
			this.donationForm = this.formBuilder.group({
				amount: [
					this.amount.toFixed(2),
					[
						Validators.required,
						Validators.min(
							this.donationOrg && this.donationOrg.minAmount
								? this.donationOrg.minAmount
								: 0
						),
						Validators.pattern(/^[0-9]*(\.[0-9]{0,2})?$/),
						Validators.max(1000)
					]
				]
			});
		} else {
			this.donationForm = this.formBuilder.group({});
			this.donationOrg = null;
			this.submitted = false;
		}
	}
	public setDonationOption(event) {
		this.errorMessage = "";
		this.setOrg(event.target.value);
	}
	public goBack() {
		AppUtil.log(
			"DmvDonationComponent goBack() == >",
			this.dmvStoreService.routeFrom
		);
		if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from === "dmv-review-cart"
		) {
			this.router.navigate(["dmv-review-cart"], { skipLocationChange: true });
		} else if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from === "shoping-cart"
		) {
			this.dmvStoreService.routeFrom = Object.create(null);
			this.router.navigate(
				[this.globalService.routerLastUrl.replace("/", "")],
				{
					skipLocationChange: true
				}
			);
		} else if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from === "dmv-manual-renew"
		) {
			const routeFrom: RouteFrom = Object.create(null);
			this.dmvStoreService.routeFrom = routeFrom;
			this.dmvStoreService.routeFrom.orderNumber =
				this.dmvStoreService.registrationsInCart.dmvRegistrationsManual.length -
				1;
			this.dmvStoreService.routeFrom.from = "dmv-donation";
			this.router.navigate(["dmv-manual-renew"], { skipLocationChange: true });
		} else if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from === "dmv-duplicate"
		) {
			const routeFrom: RouteFrom = Object.create(null);
			this.dmvStoreService.routeFrom = routeFrom;
			this.dmvStoreService.routeFrom.orderNumber =
				this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate
					.length - 1;
			this.dmvStoreService.routeFrom.from = "dmv-donation";
			this.router.navigate(["dmv-duplicate"], { skipLocationChange: true });
		} else {
			const routeFrom: RouteFrom = Object.create(null);
			this.dmvStoreService.routeFrom = routeFrom;
			this.dmvStoreService.routeFrom.orderNumber =
				this.dmvStoreService.registrationsInCart.dmvRegistrations.length - 1;
			this.router.navigate(["dmv-customize-order"], {
				skipLocationChange: true
			});
		}
	}

	public setDownIcon(event) {
		if (
			event.target &&
			event.target.offsetParent &&
			event.target.offsetParent.classList
		) {
			event.target.offsetParent.classList.remove("upArrow");
		}
	}
	public selectChangeByKey(event) {
		if (event.code === "Enter" || event.code === "Space") {
			this.selectChange(event);
		}
	}
	public selectChange(event) {
		if (
			event.target &&
			event.target.offsetParent &&
			event.target.offsetParent.classList
		) {
			if (!event.target.offsetParent.classList.contains("upArrow")) {
				event.target.offsetParent.classList.add("upArrow");
			} else {
				event.target.offsetParent.classList.remove("upArrow");
			}
		}
	}

	public setTwoNumberDecimal(event) {
		event.target.value = parseFloat(event.target.value).toFixed(2);
	}
	public continue() {
		AppUtil.log("DmvDonationComponent continue() == >");
		this.submitted = true;
		if (this.selectDonation.nativeElement.value === "selectDonation") {
			this.errorMessage = "Please select a donation option before continuing";
			return;
		}
		if (this.donationForm && this.donationForm.invalid) {
			console.log("donationForm.invalid");
			this.errorMessage = "Please correct the error indicated below";
			return;
		}

		if (this.selectDonation.nativeElement.value === "noThanks") {
			this.dmvStoreService.registrationsInCart.isDonationNoThanks = true;
		} else {
			this.dmvStoreService.registrationsInCart.isDonationNoThanks = false;
		}

		this.submitted = false;
		if (this.donationOrg) {
			const donation: Donation = {};
			donation.amount = Number(this.donationForm.controls.amount.value);
			donation.orgCode = this.donationOrg.orgCode;
			donation.name = this.donationOrg.name;

			this.dmvStoreService.registrationsInCart.donation = donation;
		} else {
			this.dmvStoreService.registrationsInCart.donation = null;
		}

		if (this.dmvStoreService.registrationsInCart.dmvRegistrations) {
			this.dmvStoreService.registrationsInCart.dmvRegistrations = this.dmvStoreService.registrationsInCart.dmvRegistrations.slice();
		} else if (
			this.dmvStoreService.registrationsInCart.dmvRegistrationsManual
		) {
			this.dmvStoreService.registrationsInCart.dmvRegistrationsManual = this.dmvStoreService.registrationsInCart.dmvRegistrationsManual.slice();
		}

		if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from === "dmv-review-cart"
		) {
			this.router.navigate(["dmv-review-cart"], { skipLocationChange: true });
		} else if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from === "shoping-cart"
		) {
			this.dmvStoreService.routeFrom = Object.create(null);
			this.router.navigate(
				[this.globalService.routerLastUrl.replace("/", "")],
				{
					skipLocationChange: true
				}
			);
		} else {
			if (this.agencyConfig.agencyDmvConfig.allowPickup) {
				this.router.navigate(["dmv-pickup-method"], {
					skipLocationChange: true
				});
			} else if (
				this.agencyConfig.agencyDmvConfig.allowAddressUpdate ||
				this.agencyConfig.agencyDmvConfig.allowMailingToTempAddress
			) {
				this.router.navigate(["dmv-pickup-mailing"], {
					skipLocationChange: true
				});
			} else {
				this.dmvStoreService.updateAddress();
				this.router.navigate(["dmv-review-cart"], {
					skipLocationChange: true
				});
			}
		}
	}
}
